import { ColumnDefinition } from './columnDefinition';
import { ColumnFilter } from './columnFilter';

export class PreviewData {
    columns: ColumnDefinition[];
    rows: { [name: string]: string };
    totalRows: number;
    filterInfo?: ColumnFilter[];
    totalSummaryFarmRows: number;
    cacheFileCreationDtTime: string;
}
